module.exports = "/images/vendor/desiigner-svg/svg/ui/quotation.svg?641fcf0514d6d6e516528468af69d249";